import { useLingui } from "@lingui/react/macro";
import { VehicleIcon } from "@offstreetparking/design-system/icons/VehicleIcon";
import { WysiwygView } from "../../../forms/Wysiwyg/WysiwygView";
import { FlowModalTitle as ModalTitle } from "../../../overlays/FlowModal/FlowModalTitle";
import { ResponsiveOverlay } from "../../../overlays/ResponsiveOverlay";

type PermitInstructionsOverlayProps = {
	isOpen: boolean;
	onClose: () => void;
	selfServiceInstructions: string;
	isEditPermitAvailable: boolean;
	isCancelPermitAvailable: boolean;
};

export const PermitInstructionsOverlay = ({
	isOpen,
	onClose,
	selfServiceInstructions,
	isEditPermitAvailable,
	isCancelPermitAvailable,
}: PermitInstructionsOverlayProps) => {
	const { t } = useLingui();

	const titleKey =
		!isEditPermitAvailable && !isCancelPermitAvailable
			? "edit-and-cancel"
			: !isEditPermitAvailable
				? "edit"
				: "cancel";

	const title =
		titleKey === "edit-and-cancel"
			? t`How to Edit or Cancel Your Permit`
			: titleKey === "edit"
				? t`How to Edit Your Permit`
				: t`How to Cancel Your Permit`;

	return (
		<ResponsiveOverlay
			isOpen={isOpen}
			onOpenChange={(open) => {
				if (!open) {
					onClose();
				}
			}}
			variant="fullScreen"
			title={
				<ModalTitle
					variant="fullScreen"
					icon={<VehicleIcon className="h-5 w-5" />}
					onClose={onClose}
					i18n={{
						closeButton: t`Close`,
					}}
				>
					{title}
				</ModalTitle>
			}
		>
			<div className="pb-6">
				<WysiwygView content={selfServiceInstructions} />
			</div>
		</ResponsiveOverlay>
	);
};
